import React from 'react'
import './create.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import Seal from '../../assets/seal.png';
import Sign from '../../assets/sign.png';

function CreateCase() {
    const navigate = useNavigate()

  return (
    <div className='create-case'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>Create Case Document</h2>
                    </div>
                    <p>Please fill in the inputs and append seal and signature </p>
                </div>
                <p className="nav-status">Home/Specifications/Document-Upload-Form/Case-Documents</p>
            </div>
            <div className="form">
                <div className="left-side">
                    <div className="input-create">
                        <label htmlFor="doc-title">Document Title</label>
                        <input type="text" id='doc-title' placeholder='e.g. STATEMENT OF COMPLIANCE' />
                    </div>
                    <div className="input-create">
                        <label htmlFor="legal-contact">Legal Counsel Information</label>
                        <textarea id="legal-contact" placeholder='Enter Legal Counsel Information'></textarea>
                    </div>
                    <div className="input-create">
                        <label htmlFor="division">Division</label>
                        <input type="text" id='division' placeholder='e.g. Ikeja' />
                    </div>
                    <div className="input-create">
                        <label htmlFor="defendant">Add Defendant</label>
                        <div className="btn-input">
                            <input type="text" id='defendant' placeholder='e.g Mr Rasheed'/>
                            <button>Add <FontAwesomeIcon icon={faPlusCircle} /></button>
                        </div>
                    </div>
                    <div className="input-create">
                        <label htmlFor="service-address">Service Address</label>
                        <div className="btn-input">
                            <input type="text" id='service-address' placeholder='Enter Service Address'/>
                            <button>Add <FontAwesomeIcon icon={faPlusCircle} /></button>
                        </div>
                    </div>
                    <div className="input-create">
                        <label htmlFor="claims">Claimant's Claims</label>
                        <div className="btn-input">
                            <textarea id="claims" placeholder='This Field is for Claimants claim against the defendant only. Enter each  claim at a time and click “Add” without paragraph numbering or bullets, auto numbering will take care of numbers.'></textarea>
                            <button>Add <FontAwesomeIcon icon={faPlusCircle} /></button>
                        </div>
                    </div>
                    <div className="input-create">
                        <label htmlFor="suit-num">Suit Number</label>
                        <input type="text" id='suit-num' placeholder='e.g. ID/4512LCM/2021' />
                    </div>
                    <div className="input-create">
                        <label htmlFor="paragraph">Paragraph</label>
                        <div className="btn-input">
                            <textarea id="paragraph" placeholder='Enter one paragraph statement at a time and click “Add” without paragraph numbering or bullets, auto numbering will take care of numbers.'></textarea>
                            <button>Add <FontAwesomeIcon icon={faPlusCircle} /></button>
                        </div>
                    </div>
                    <div className="input-create">
                        <label htmlFor="dep-date">Counsel or Deponent Date</label>
                        <input type="date" id='dep-date' />
                    </div>
                    <div className="input-create">
                        <label htmlFor="add-claim">Add Claimant</label>
                        <div className="btn-input">
                            <input type="text" id='add-claim' placeholder='e.g Mr Rasheed'/>
                            <button>Add <FontAwesomeIcon icon={faPlusCircle} /></button>
                        </div>
                    </div>
                </div>
                <div className="right-side">
                    <div className="append">
                        <img src={Seal} alt="Seal" />
                        <div className="append-create">
                            <input type="file" id="append-seal" />
                            <label htmlFor="append-seal">Append Seal</label>
                        </div>
                    </div>
                    <div className="append">
                        <img src={Sign} alt="Signature" />
                        <div className="append-create">
                            <input type="file" id="append-sign" />
                            <label htmlFor="append-sign">Append Signature</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="down">
                <div className="goBack" onClick={() => navigate('/upload') }>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <p>Back to Upload</p>
                </div>
                <div className="btns">
                    <button 
                    className="upload" 
                    >
                        Preview Document <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CreateCase